import Component from '../../shared/component';
import StarRating from './star-rating';

export default class MentorshipRatingForm extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$mentorRatingFormContainer = this.$element.find(
      '.userQuickInfos-mentorRatingForm'
    );
    this.$mentorRatingForm = this.$mentorRatingFormContainer.find('form');
    this.$mentorRatingFormCancelButton = this.$mentorRatingForm.find(
      '.mentorshipRatingForm-button--cancel'
    );

    this.$userInfos = this.$element.find('.userQuickInfos-userInfos');

    this.bindEvents();
  }

  bindEvents() {
    this.handleStarClick = this.handleStarClick.bind(this);
    this.handleCancelButtonClick = this.handleCancelButtonClick.bind(this);
    this.handleFormSuccess = this.handleFormSuccess.bind(this);

    this.$userInfos.on(
      'click.MentorshipRatingForm',
      '.starRating-image',
      this.handleStarClick
    );
    this.$mentorRatingFormCancelButton.on(
      'click.MentorshipRatingForm',
      this.handleCancelButtonClick
    );
    this.$mentorRatingForm.on(
      'ajax:success.MentorshipRatingForm',
      this.handleFormSuccess
    );

    this.starRating = new StarRating(
      this.$mentorRatingForm.find('.starRating')
    );
  }

  unbindEvents() {
    this.$userInfos.off('click', '.starRating-image', this.handleStarClick);
    this.$mentorRatingFormCancelButton.off(
      'click',
      this.handleCancelButtonClick
    );
    this.$mentorRatingForm.off('ajax:success', this.handleFormSuccess);

    this.starRating.unbindEvents();
  }

  handleStarClick(event) {
    const $target = $(event.target);

    const rating = $target.data('rating');

    this.showMentorRatingForm();
    this.setMentorRating(rating);
  }

  handleCancelButtonClick() {
    this.showUserInfos();
  }

  handleFormSuccess() {
    // This makes sure that opening and submitting this form
    // from different places in the Messages UI doesn’t cause
    // unexpected glitches
    window.Turbolinks.clearCache();

    $(document).one('turbolinks:load.MentorshipRatingForm', () => {
      setTimeout(() => {
        $('.userQuickInfos-ratingForm-confirmation').show();
      }, 100);
    });

    window.Turbolinks.reload({keepScrollPosition: true});
  }

  showMentorRatingForm() {
    this.$mentorRatingFormContainer.show();
    this.$userInfos.hide();
  }

  showUserInfos() {
    this.$userInfos.show();
    this.$mentorRatingFormContainer.hide();
  }

  setMentorRating(rating) {
    this.$mentorRatingFormContainer
      .find(`.starRating-image[data-rating="${rating}"]`)
      .trigger('click');
  }
}
